import React from 'react';
import { PersonalLoanPrequalFunnel } from 'partial/OfferManager/modules/PersonalLoanMarketplaceModule/components/PersonalLoanPrequal/PersonalLoanPrequalFunnel';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import classnames from 'classnames';
import './PersonalLoanPrequalModule.scss';
import { commafy } from 'helpers/number';

const ActionsModuleView = props => {
  const { creditInfo } = props;

  const creditCardDebt =
    creditInfo &&
    creditInfo.debtAnalysis &&
    creditInfo.debtAnalysis.creditCardDebt
      ? '$' + commafy(creditInfo.debtAnalysis.creditCardDebt.totalDebt)
      : '';
  return (
    <SectionContainer className="personalLoanPrequalModuleInner">
      <Row>
        <Label type="H3" typeHeader={'h3'} className="margB16">
          Need money to help pay off your {creditCardDebt + ' '}credit card
          debt?
        </Label>
        <Label
          type="Body-1"
          className="margB24 m-text-14"
          datatestid={'prequalmodule-subHeader'}
        >
          Check for pre-qualified personal loan offers below and find your best
          match.
        </Label>
        <PersonalLoanPrequalFunnel
          showPrequalTopModule={true}
          isOverview={false}
          {...props}
        />
      </Row>
    </SectionContainer>
  );
};

const PersonalLoanPrequalModuleView = props => {
  const { isActionsModule, seenPixel } = props;

  const wrapperClass = classnames('personalLoanPrequalModule', {
    actionsPageModule: isActionsModule,
  });

  return (
    <>
      {seenPixel}
      <div className={wrapperClass}>
        {isActionsModule ? (
          <ActionsModuleView {...props} />
        ) : (
          <PersonalLoanPrequalFunnel
            showPrequalTopModule={true}
            isOverview={true}
            {...props}
          />
        )}
      </div>
    </>
  );
};

export { PersonalLoanPrequalModuleView };
